module.exports = __webpack_public_path__ + "img/ic_drawer_3.9c32a137.svg";